module.exports = __webpack_public_path__ + "img/fullscreen.0d500bb3.svg";